import { confirmResetPassword, resetPassword } from "aws-amplify/auth";
import { useState } from "react";

const ForgotPassword = () => {
  const [username, setUsername] = useState("");
  const [code, setCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [step, setStep] = useState("request");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [codeHint, setCodeHint] = useState("");

  const handleRequestCode = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    setLoading(true);
    try {
      const out = await resetPassword({ username: username.trim() });
      const dest = out.nextStep?.codeDeliveryDetails?.destination;
      setCodeHint(dest ? `Code sent to ${dest}.` : "Check your email for the reset code.");
      setMessage("If an account exists for this email, a verification code has been sent.");
      setStep("confirm");
    } catch (err) {
      console.error(err);
      setError(err.message || "Could not start password reset.");
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmReset = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }
    setLoading(true);
    try {
      await confirmResetPassword({
        username: username.trim(),
        confirmationCode: code.trim(),
        newPassword,
      });
      setMessage("Password updated. You can sign in with your new password.");
      setStep("done");
    } catch (err) {
      console.error(err);
      setError(err.message || "Could not reset password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-base-200 flex min-h-screen items-center justify-center px-4">
      <div className="card bg-base-100 w-full max-w-md shadow-xl">
        <div className="card-body">
          <h2 className="card-title justify-center text-2xl">Forgot password</h2>

          {error && <div className="alert alert-error text-sm">{error}</div>}
          {message && <div className="alert alert-info text-sm">{message}</div>}

          {step === "request" && (
            <form onSubmit={handleRequestCode} className="space-y-4">
              <p className="text-sm opacity-80">
                Enter the email address for your account. We will send a verification code you can use to choose a new
                password.
              </p>
              <input
                type="email"
                name="username"
                placeholder="Email"
                className="input input-bordered w-full"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
              <button type="submit" className="btn btn-primary w-full" disabled={loading}>
                {loading ? "Sending…" : "Send reset code"}
              </button>
            </form>
          )}

          {step === "confirm" && (
            <form onSubmit={handleConfirmReset} className="space-y-4">
              {codeHint && <p className="text-sm opacity-80">{codeHint}</p>}
              <input
                type="text"
                name="code"
                inputMode="numeric"
                autoComplete="one-time-code"
                placeholder="Verification code"
                className="input input-bordered w-full"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                required
              />
              <input
                type="password"
                name="newPassword"
                placeholder="New password"
                className="input input-bordered w-full"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
                minLength={8}
              />
              <input
                type="password"
                name="confirmPassword"
                placeholder="Confirm new password"
                className="input input-bordered w-full"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                minLength={8}
              />
              <button type="submit" className="btn btn-primary w-full" disabled={loading}>
                {loading ? "Updating…" : "Set new password"}
              </button>
            </form>
          )}

          {step === "done" && (
            <p className="text-center text-sm">
              <a href="/login" className="link link-primary">
                Back to login
              </a>
            </p>
          )}

          {step !== "done" && (
            <p className="mt-2 text-center text-sm">
              <a href="/login" className="link link-primary">
                Back to login
              </a>
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
